module.exports = __webpack_public_path__ + "47020258721263b409b40b6243e7a172.png";